var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticStyle:{"min-height":"0 !important"},attrs:{"id":"infoset-page"}},[_c('ContactAndSalesInfoModal'),_c('ReactivationAndReengagementModal'),_c('InfosetContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }